import { useCallback, useRef } from "react";
import { DEBOUNCE_DELAY } from "../utils";

export const useDebounce = (
  callback: () => void,
  delay: number = DEBOUNCE_DELAY
) => {
  const timeoutRef = useRef<NodeJS.Timeout>();

  return useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      callback();
    }, delay);
  }, [callback, delay]);
};
